import React from 'react';
import { TitleMedium } from '../../common/components/v2';
import styles from './styles.module.scss';

export const DashboardHeader = ({ title }: { title: string }) => {
  return (
    <div className={styles.Header}>
      <div>
        <TitleMedium>{title}</TitleMedium>
      </div>
    </div>
  );
};
